import React from "react";
import { NavLink } from "react-router-dom";

import releasesIcon from "../../assets/icons/releases.svg";
import chartsIcon from "../../assets/icons/charts.svg";
import playlistIcon from "../../assets/icons/playlist.svg";
import exclusivesIcon from "../../assets/icons/exclusives.svg";
import remixersIcon from "../../assets/icons/remixers.svg";
import searchIcon from "../../assets/icons/Search.png";
import ProducerIcon from "../../assets/producer/Group.png";

const navItems = [
  { name: "Releases", icon: releasesIcon, path: "/releases" },
  { name: "Charts", icon: chartsIcon, path: "/charts" },
  { name: "Playlists", icon: playlistIcon, path: "/playlist" },
  { name: "Exclusives", icon: exclusivesIcon, path: "/exclusives" },
  { name: "Producers", icon: ProducerIcon, path: "/producer-packs" },
  { name: "Remixers", icon: remixersIcon, path: "/remixers" },
  { name: "Search", icon: searchIcon, path: null },
];

const MobileBottomNavbar = () => {
  return (
    <div className="fixed bottom-[-3px] left-0 right-0 bg-[#080B12] border-t border-[#1A1A1A] flex justify-between items-center px-1 sm:px-2 md:px-4 py-1 sm:py-2 lg:hidden z-[5999]">
      {navItems.map((item, index) =>
        item.name === "Search" ? (
          <button
            key={index}
            onClick={() =>
              window.dispatchEvent(new CustomEvent("openFilterModal"))
            }
            className="flex flex-col items-center justify-center text-[8px] sm:text-[9px] md:text-[10px] text-[#E2E2E2] gap-[2px] sm:gap-[3px] font-['Public Sans'] w-full opacity-80 hover:opacity-100 py-1 sm:py-0"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="w-[16px] h-[16px] sm:w-[17px] sm:h-[17px] md:w-[18px] md:h-[18px] opacity-60"
            >
              <path
                d="M8.25 15C10.0402 15 11.7571 14.2888 13.023 13.023C14.2888 11.7571 15 10.0402 15 8.25C15 6.45979 14.2888 4.7429 13.023 3.47703C11.7571 2.21116 10.0402 1.5 8.25 1.5C6.45979 1.5 4.7429 2.21116 3.47703 3.47703C2.21116 4.7429 1.5 6.45979 1.5 8.25C1.5 10.0402 2.21116 11.7571 3.47703 13.023C4.7429 14.2888 6.45979 15 8.25 15ZM14.1975 15.5175C14.595 16.7175 15.5025 16.8375 16.2 15.7875C16.8375 14.8275 16.4175 14.04 15.2625 14.04C14.4075 14.0325 13.9275 14.7 14.1975 15.5175Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="leading-tight">Search</span>
          </button>
        ) : (
          <NavLink
            to={item.path}
            key={index}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center text-[8px] sm:text-[9px] md:text-[10px] text-[#E2E2E2] gap-[2px] sm:gap-[3px] font-['Public Sans'] w-full py-1 sm:py-0 ${
                isActive ? "text-[#40E0D0]" : "opacity-80 hover:opacity-100"
              }`
            }
          >
            <img
              src={item.icon}
              alt={item.name}
              className="w-[16px] h-[16px] sm:w-[18px] sm:h-[18px] md:w-[20px] md:h-[20px]"
            />
            <span className="leading-tight whitespace-nowrap overflow-hidden text-ellipsis max-w-[50px] sm:max-w-none">
              {item.name}
            </span>
          </NavLink>
        )
      )}
    </div>
  );
};

export default MobileBottomNavbar;